module.exports = __webpack_public_path__ + "static/img/meet-the-team_5.80d7d36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/consulting/meet-the-team_5.png
// module id = x8sv
// module chunks = 0